import type { Payment } from "@/payments/types/payments";

export const formatPaymentCard = (payment: Payment): string => {
  const charge = payment.latest_charge;
  const details = charge && typeof charge === "object" ? charge.payment_method_details : undefined;
  const method = payment.payment_method;
  const expandedMethod = method && typeof method === "object" ? method : undefined;
  const card = [
    details?.card_present,
    details?.card,
    details?.interac_present,
    expandedMethod?.card_present,
    expandedMethod?.card,
    expandedMethod?.interac_present,
  ].find((value) => value?.brand || value?.last4);

  return [card?.brand?.toUpperCase(), card?.last4 ? `****${card.last4}` : ""]
    .filter(Boolean)
    .join(" ");
};
